<template>
  <div class="product_recom container" v-if="recomProductItems.length > 0">
    <h3 class="stitle mb50">추천상품</h3>
    <ul>
      <template v-if="loading">
        <li v-for="i in 4" :key="i">
          <span>
            <SkeletonBox width="100%" height="0" paddingTop="85.7%" />
          </span>
          <dl>
            <dt><SkeletonBox :minWidth="30" :maxWidth="80" /></dt>
            <dd>
              <SkeletonBox :minWidth="80" :maxWidth="100" />
              <SkeletonBox :minWidth="30" :maxWidth="70" />
            </dd>
          </dl>
        </li>
      </template>
      <template v-else>
        <li v-for="productItem in recomProductItems" :key="'rc_' + productItem.mrktnPdNo">
          <router-link
            :to="{
              path: `/${currentRouteType}/${$route.params.expDiv}/${productItem.mrktnPdNo}`,
            }"
          >
            <span>
              <div class="thumbnail">
                <div class="thumbnail-centered">
                  <img :src="productItem.filePath" :alt="productItem.pdNm" @error="$changeDefaultImage" class="thumbnail-img" />
                </div>
                <!---->
                <!-- <SkeletonBox width="100%" height="0" paddingTop="85.7%" :image="productItem.filePath" :alt="productItem.pdNm"></SkeletonBox> -->
              </div>
            </span>
            <dl>
              <dt>{{ productItem.mrktnPdNm }}</dt>
              <dd class="explan" v-html="productItem.salepdExpl"></dd>
            </dl>
          </router-link>
        </li>
        <!--채우기-->
        <li v-for="i in emtpyLength" :key="i"></li>
      </template>
    </ul>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
  components: {},
  data() {
    return {};
  },
  computed: {
    ...mapState({ loading: (state) => state.product.loadingItems }),
    ...mapGetters(['recomProductItems']),
    emtpyLength() {
      const length = 4 - this.recomProductItems.length;
      return length > 0 ? length : 0;
    },
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.thumbnail {
  position: relative;
  padding-top: 85%;
  overflow: hidden;
}

.thumbnail-centered {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  transform: translate(50%, 50%);
}

.thumbnail-img {
  /*   max-width: 100%; */
  /*   height: 박스의 height와 같아야 한다. */
  transform: translate(-50%, -50%);
}

#productList .product_recom li span {
  & img {
    object-fit: cover;
    width: 100%;
    height: 100%;
  }
}
@media (max-width: 540px) {
  #productList .product_recom li dt {
    font-size: 19px;
    word-break: break-word;
  }

    #productList .explan {
    font-size: 14px;
  }
}
</style>
